// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { Announcement, CalendarEvent, MediaAttachment, Message, Post } from "../../../Utilities";

export type Base = {
	displayOrder: MediaAttachment["displayOrder"] | null;
	title: MediaAttachment["title"];
	description: MediaAttachment["description"];
	isFile: MediaAttachment["isFile"];
	fileKey: MediaAttachment["fileKey"];
	fileContentType: MediaAttachment["fileContentType"];
	linkURL: MediaAttachment["linkURL"];
	announcementID: Announcement["id"] | null;
	calendarEventID: CalendarEvent["id"] | null;
	messageID: Message["id"] | null;
	postID: Post["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, never>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	displayOrder: null,
	title: "",
	description: "",
	isFile: false,
	fileKey: "",
	fileContentType: "",
	linkURL: "",
	announcementID: null,
	calendarEventID: null,
	messageID: null,
	postID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInAnnouncement = Omit<Create, "announcementID">;

export type CreateInAnnouncementRequiredKey = Exclude<CreateRequiredKey, "announcementID">;

export type CreateInAnnouncementSubset<K extends keyof CreateInAnnouncement = keyof CreateInAnnouncement> = Pick<
	CreateInAnnouncement,
	CreateInAnnouncementRequiredKey | K
>;

export const blankItemInAnnouncement: CreateInAnnouncement = omitKeys(initialCreate, ["announcementID"]);

export type CreateInCalendarEvent = Omit<Create, "calendarEventID">;

export type CreateInCalendarEventRequiredKey = Exclude<CreateRequiredKey, "calendarEventID">;

export type CreateInCalendarEventSubset<K extends keyof CreateInCalendarEvent = keyof CreateInCalendarEvent> = Pick<
	CreateInCalendarEvent,
	CreateInCalendarEventRequiredKey | K
>;

export const blankItemInCalendarEvent: CreateInCalendarEvent = omitKeys(initialCreate, ["calendarEventID"]);

export type CreateInMessage = Omit<Create, "messageID">;

export type CreateInMessageRequiredKey = Exclude<CreateRequiredKey, "messageID">;

export type CreateInMessageSubset<K extends keyof CreateInMessage = keyof CreateInMessage> = Pick<
	CreateInMessage,
	CreateInMessageRequiredKey | K
>;

export const blankItemInMessage: CreateInMessage = omitKeys(initialCreate, ["messageID"]);

export type CreateInPost = Omit<Create, "postID">;

export type CreateInPostRequiredKey = Exclude<CreateRequiredKey, "postID">;

export type CreateInPostSubset<K extends keyof CreateInPost = keyof CreateInPost> = Pick<
	CreateInPost,
	CreateInPostRequiredKey | K
>;

export const blankItemInPost: CreateInPost = omitKeys(initialCreate, ["postID"]);
